import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class ProductApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.PRODUCT);
  }

  getTaxTypes() {
    return this.httpClient.get(`${this.getResourceUrl()}tax-types/`);
  }

  exportProduct(params = new URLSearchParams()) {
    const queryString = params.toString();
    const url = queryString
      ? `${this.getResourceUrl()}export/?${queryString}`
      : `${this.getResourceUrl()}export/`;

    return this.httpClient.get(url);
  }
}

export default new ProductApi();
